import ApplicantForm from "./addApplicant";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  onClose: Function;
  refreshFunction: Function;
};

const AddApplicant = ({ toggleModal, urlTittle, onClose, refreshFunction }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={"Carga de Postulante"}
        titleStyle={styles}
        urlTittle={urlTittle}
      >
        <ApplicantForm onClose={onClose} refreshFunction={refreshFunction}/>
      </Modal>
    </>
  );
};

export default AddApplicant;
